/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Machine-readable join-request failure category.
 */
export type CalendarJoinRequestErrorCode =
  (typeof CalendarJoinRequestErrorCode)[keyof typeof CalendarJoinRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarJoinRequestErrorCode = {
  not_found: 'not_found',
  already_on_calendar: 'already_on_calendar',
  sharer_cannot_invite: 'sharer_cannot_invite',
  request_declined: 'request_declined',
  internal: 'internal',
} as const;
